import React, { FC } from 'react'

import { IconRoutinesProps } from './IconRoutines.types'
import * as Styled from './styles/IconRoutines.style'

import { nonThemeableRules } from '../../ruleSet'

const IconRoutines: FC<IconRoutinesProps> = ({
  size = nonThemeableRules.defaultSize as number as IconRoutinesProps['size'],
  isResponsive = false,
}: IconRoutinesProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M24.003 3.827v5.385m0 29.576v5.385M3.823 24H9.21m29.572 0h5.386M9.78 9.688l3.805 3.81M34.498 34.41l3.81 3.808m-28.62.095 3.807-3.81m20.91-20.913 3.807-3.807M24.05 33.682a9.71 9.71 0 0 0 9.71-9.71c0-5.362-4.347-9.71-9.71-9.71s-9.71 4.348-9.71 9.71a9.71 9.71 0 0 0 9.71 9.71Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M21.285 15.08a9.25 9.25 0 0 1 .073 17.818' stroke='#0D0D0D' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
        <path
          d='M21.285 15.08a9.25 9.25 0 0 1 .073 17.818l-.658.19a9.71 9.71 0 1 0 .1-18.268l.485.26Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconRoutines
